import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-arranger-details',
    templateUrl: './arranger-details.component.html',
    styleUrls: ['./arranger-details.component.scss']
})
export class ArrangerDetailsComponent implements OnInit {

    constructor() {}
    ngOnInit(): void {}

}
